// Rarity-related constants
export const RARITY_VALUES = {
  ALL: 'all',
  LIMITED: 'limited',
  RARE: 'rare',
  SUPER_RARE: 'super_rare',
  UNIQUE: 'unique',
  CUSTOM_SERIES: 'custom_series',
} as const;

// Rarity display names
export const RARITY_DISPLAY_NAMES = {
  [RARITY_VALUES.ALL]: 'All Rarities',
  [RARITY_VALUES.LIMITED]: 'Limited',
  [RARITY_VALUES.RARE]: 'Rare',
  [RARITY_VALUES.SUPER_RARE]: 'Super Rare',
  [RARITY_VALUES.UNIQUE]: 'Unique',
  [RARITY_VALUES.CUSTOM_SERIES]: 'Custom Series',
};

// Rarity colors for UI styling (aligned with --sa-rarity-* in tokens.css)
export const RARITY_COLORS = {
  [RARITY_VALUES.LIMITED]: 'var(--sa-rarity-limited)',
  [RARITY_VALUES.RARE]: 'var(--sa-rarity-rare)',
  [RARITY_VALUES.SUPER_RARE]: 'var(--sa-rarity-super-rare)',
  [RARITY_VALUES.UNIQUE]: 'var(--sa-rarity-unique)',
};

// Default rarity values
export const DEFAULT_RARITY = RARITY_VALUES.ALL;
export const DEFAULT_RARITY_PRICES = RARITY_VALUES.SUPER_RARE;
